"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.createRequires = exports["default"] = void 0;
var loadRemoteModule_1 = require("./lib/loadRemoteModule");
__createBinding(exports, loadRemoteModule_1, "createLoadRemoteModule", "default");
var createRequires_1 = require("./lib/createRequires");
__createBinding(exports, createRequires_1, "createRequires");
//# sourceMappingURL=index.js.map